<h4 mat-dialog-title>Редактирование настраиваемых полей</h4>
<app-close-button [formGroup]="customFieldsForm" [dialogRef]="dialogRef"/>
@if (loading()) {
    <app-loader [isLoading]="loading()"></app-loader>
} @else {
    <mat-dialog-content>
        <form class="flex-column" [formGroup]="customFieldsForm" (ngSubmit)="onSubmit()">

            <mat-form-field appearance="fill">
                <mat-label>Название поля</mat-label>
                <input matInput formControlName="label" />
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Название поля в системе клиента</mat-label>
                <input matInput formControlName="customId" />
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Тип поля</mat-label>
                <mat-select formControlName="type">
                    @for (type of enumService.enumToArrSelects(CustomFieldTypeEnum); track type.value) {
                        <mat-option [value]="type.value">{{type.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-checkbox formControlName="required">
                Обязательное ли к заполнению поле.
            </mat-checkbox>

            <app-common-dropdown
                [label]="'Проект'"
                [formCtrl]="customFieldsForm.controls.projectId"
                [service]="projectSelectorService"
            ></app-common-dropdown>

            <div class="flex justify-between">
                <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!customFieldsConfig.data.id" (click)="deleteCustomField(customFieldsConfig.data.id)">Удалить</button>
                <button mat-flat-button class="w-40" color="primary" type="submit"
                        [disabled]="customFieldsForm.invalid && customFieldsForm.controls.projectId.value === 0">Сохранить</button>
            </div>

        </form>
    </mat-dialog-content>
}
